import {
  UPDATE_SEARCH_USER_DATA,
  UPDATE_USER_DATA,
  UPDATE_SEARCH_QUERY,
  UPDATE_CURRENT_PAGE
} from "./actions/storeActions";
import { combineReducers } from "redux";

const userData = (val = null, action) => {
  switch (action.type) {
    case UPDATE_USER_DATA:
      return action.val;
    default:
      return val;
  }
};

const initialState = {
  formData: {
    firstName: "",
    lastName: "",
    email: "",
    studentEmail: "",
    phoneNumber: "",
    knaekID: "",
    mandateNumber: "",
    iban: "",
    creditCard: "",
    accountOwner: "",
    channelName: "",
    extensiveSearch: false,
    // Add search and pagination state
    searchQuery: "",
    currentPage: 1,
  },
};

const formData = (state = initialState.formData, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_USER_DATA:
      return action.data;
    case UPDATE_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: action.searchQuery,
        currentPage: 1 // Reset to page 1 when search changes
      };
    case UPDATE_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.currentPage
      };
    default:
      return state;
  }
};

export default combineReducers({ userData, formData });
